module.exports = __webpack_public_path__ + "static/image/history/m/201303@3x.ver2_0_2.jpg?fb3a9f41";